/**
 * Sticky Add-to-Cart — mobile uniquement
 */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  var anchor = document.querySelector('[data-hp-satc]');
  if (!anchor) return;

  var sid      = anchor.dataset.hpSatc;
  var sizeIdx  = parseInt(anchor.dataset.hpSizeIdx  || '0', 10);
  var colorIdx = parseInt(anchor.dataset.hpColorIdx || '0', 10);
  var sizeName = anchor.dataset.hpSizeName || '';
  var isFr     = document.documentElement.lang.indexOf('fr') === 0;

  var origBtn = document.getElementById('ProductSubmitButton-' + sid);
  if (!origBtn) return;

  var variantsEl = document.getElementById('hp-satc-variants-' + sid);
  if (!variantsEl) return;
  var variants = JSON.parse(variantsEl.textContent);

  /* ---- Créer la barre ---- */
  var style = document.createElement('style');
  style.textContent =
    '.hp-satc{position:fixed;bottom:0;left:0;right:0;z-index:9999;background:#fff;' +
    'border-top:1px solid #e0e0e0;padding:12px 16px max(16px,env(safe-area-inset-bottom));' +
    'transform:translateY(110%);transition:transform .25s ease;box-shadow:0 -2px 12px rgba(0,0,0,.07);}' +
    '.hp-satc--on{transform:translateY(0);}' +
    '.hp-satc__sizes{display:flex;gap:18px;margin-bottom:8px;flex-wrap:wrap;}' +
    '.hp-satc__sz{font-size:13px;color:#111;background:none;border:none;padding:2px 0;' +
    'cursor:pointer;opacity:.3;font-family:inherit;letter-spacing:.02em;line-height:1.4;}' +
    '.hp-satc__sz--ok{opacity:1;}' +
    '.hp-satc__sz--sel{opacity:1;text-decoration:underline;text-underline-offset:3px;}' +
    '.hp-satc__sz--out{opacity:.25;text-decoration:line-through;}' +
    '.hp-satc__del{display:none;align-items:center;gap:6px;font-size:11px;color:#555;margin-bottom:8px;}' +
    '.hp-satc__del--on{display:flex;}' +
    '.hp-satc__btn{width:100%;background:#111;color:#fff;border:none;padding:15px 20px;' +
    'display:flex;align-items:center;justify-content:space-between;font-size:12px;' +
    'letter-spacing:.1em;text-transform:uppercase;cursor:pointer;font-family:inherit;}' +
    '.hp-satc__btn:disabled{background:#999;cursor:default;}';
  document.head.appendChild(style);

  var bar = document.createElement('div');
  bar.className = 'hp-satc';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML =
    '<div class="hp-satc__sizes" id="hp-satc-sizes"></div>' +
    '<div class="hp-satc__del" id="hp-satc-del"></div>' +
    '<button type="button" class="hp-satc__btn" id="hp-satc-btn" disabled>' +
      '<span>' + (isFr ? 'Ajouter au panier' : 'Add to cart') + '</span>' +
      '<span id="hp-satc-price"></span>' +
    '</button>';
  document.body.appendChild(bar);

  var sizesEl = document.getElementById('hp-satc-sizes');
  var delEl   = document.getElementById('hp-satc-del');
  var satcBtn = document.getElementById('hp-satc-btn');
  var priceEl = document.getElementById('hp-satc-price');
  var selSize = null;

  /* ---- Date livraison ---- */
  function bizDate(n) {
    var d = new Date(), a = 0;
    while (a < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w && w < 6) a++; }
    return d;
  }
  var DAYS   = isFr ? ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'] : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MONTHS = isFr ? ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'] : ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function dlabel() { var d = bizDate(3); return DAYS[d.getDay()] + ' ' + String(d.getDate()).padStart(2,'0') + ' ' + MONTHS[d.getMonth()]; }

  /* ---- Helpers variantes ---- */
  function prop(v, idx) { return idx === 1 ? v.o1 : idx === 2 ? v.o2 : idx === 3 ? v.o3 : null; }

  function getMainVid() {
    var inp = document.querySelector('[data-section-id="' + sid + '"] .product-variant-id') || document.querySelector('.product-variant-id');
    return inp ? String(inp.value) : null;
  }

  function getColor() {
    if (!colorIdx) return null;
    var v = variants.find(function (x) { return String(x.id) === getMainVid(); });
    return v ? prop(v, colorIdx) : null;
  }

  function findVariant(size, color) {
    return variants.find(function (v) {
      if (prop(v, sizeIdx) !== size) return false;
      if (colorIdx && color && prop(v, colorIdx) !== color) return false;
      return true;
    }) || null;
  }

  function sizesForColor(color) {
    var seen = {}, out = [];
    variants.forEach(function (v) {
      if (colorIdx && prop(v, colorIdx) !== color) return;
      var sz = prop(v, sizeIdx);
      if (sz && !seen[sz]) { seen[sz] = true; out.push({ size: sz, v: v }); }
    });
    return out;
  }

  /* ---- UI ---- */
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updatePrice() {
    var vid = getMainVid();
    var v = vid ? variants.find(function (x) { return String(x.id) === vid; }) : null;
    if (!v || !priceEl) return;
    if (v.cp && v.cp > v.p) {
      var pct = Math.round((1 - v.p / v.cp) * 100);
      priceEl.innerHTML =
        formatMoney(v.p) +
        ' <span style="text-decoration:line-through;opacity:.5;font-size:11px">' + formatMoney(v.cp) + '</span>' +
        ' <span style="font-size:11px">-' + pct + '%</span>';
    } else if (v.p) {
      priceEl.textContent = formatMoney(v.p);
    }
  }

  function updateDel(size, color) {
    if (!size) { delEl.classList.remove('hp-satc__del--on'); return; }
    var v = findVariant(size, color);
    if (!v || !v.av) { delEl.classList.remove('hp-satc__del--on'); return; }
    var low = v.im === 'shopify' && v.iq > 0 && v.iq <= 10;
    var dot = low ? '#f97316' : '#3ed660';
    var txt = isFr
      ? (low ? 'Stock limité' : 'En stock') + ' : livré chez vous ' + dlabel()
      : (low ? 'Limited stock' : 'In stock') + ' : delivered to you ' + dlabel();
    delEl.innerHTML = '<svg width="8" height="8" viewBox="0 0 8 8" style="flex-shrink:0"><circle cx="4" cy="4" r="4" fill="' + dot + '"/></svg><span>' + txt + '</span>';
    delEl.classList.add('hp-satc__del--on');
  }

  function build() {
    var color = getColor();
    var vid   = getMainVid();
    var cur   = variants.find(function (x) { return String(x.id) === vid; });

    if (cur) {
      var curSz = prop(cur, sizeIdx);
      if (selSize) {
        if (!findVariant(selSize, color)) selSize = curSz;
      } else {
        selSize = curSz;
      }
    }

    if (sizeIdx === 0) { satcBtn.disabled = false; updatePrice(); return; }

    var list = sizesForColor(color);
    sizesEl.innerHTML = '';
    list.forEach(function (item) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = item.size;
      var cls = 'hp-satc__sz';
      if (!item.v.av) cls += ' hp-satc__sz--out'; else cls += ' hp-satc__sz--ok';
      if (item.size === selSize) cls += ' hp-satc__sz--sel';
      b.className = cls;
      b.addEventListener('click', function () { onSzClick(item.size); });
      sizesEl.appendChild(b);
    });

    var sv = selSize ? findVariant(selSize, color) : null;
    satcBtn.disabled = !sv || !sv.av;
    updateDel(userPickedSize ? selSize : null, color);
    updatePrice();
  }

  var userPickedSize = false;

  function onSzClick(size) {
    selSize = size;
    userPickedSize = true;
    if (sizeName) {
      var radio = document.querySelector('input[name="' + sizeName + '"][value="' + size + '"]');
      if (radio && !radio.checked) radio.click();
    }
    build();
  }

  /* ---- ATC ---- */
  satcBtn.addEventListener('click', function () {
    var color = getColor();
    if (selSize) {
      var v = findVariant(selSize, color);
      if (v) {
        var inp = document.querySelector('[data-section-id="' + sid + '"] .product-variant-id') || document.querySelector('.product-variant-id');
        if (inp) inp.value = v.id;
      }
    }
    var mainBtn = document.getElementById('ProductSubmitButton-' + sid);
    if (mainBtn && !mainBtn.disabled) mainBtn.click();
  });

  /* ---- IntersectionObserver ---- */
  new IntersectionObserver(function (entries) {
    var out = !entries[0].isIntersecting;
    bar.classList.toggle('hp-satc--on', out);
    bar.setAttribute('aria-hidden', String(!out));
  }, { threshold: 0.01 }).observe(origBtn);

  /* ---- Écoute changement variante ---- */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(build, 80); });
  }

  build();
})();
